module.exports = __webpack_public_path__ + "img/yss.57c1bd1a.png";